let csrfToken = "";

export function clearSession(): void {
  csrfToken = "";
}

export async function api<T>(url: string, init?: RequestInit): Promise<T> {
  const method = init?.method?.toUpperCase() || "GET";
  const publicRequest = url === "/api/install" || url === "/api/auth/login";
  const headers = new Headers(init?.headers);
  if (!["GET", "HEAD", "OPTIONS"].includes(method) && !publicRequest) {
    if (!csrfToken) csrfToken = (await api<{ token: string }>("/api/auth/csrf")).token;
    headers.set("x-csrf-token", csrfToken);
  }
  const response = await fetch(url, { cache: "no-store", ...init, headers });
  const payload = await response.json();
  if (response.status === 401 && !publicRequest) {
    clearSession();
    window.dispatchEvent(new Event("hotcoin:unauthorized"));
  }
  if (!response.ok) throw new Error(payload.message || payload.error || `HTTP ${response.status}`);
  return payload as T;
}
